import React, { useContext, useEffect, useState } from "react";
import New_Lottie from "../../Animation/new_lottie/New_Lottie";
import Store_Product_Card from "../../HomePage/new_in_store/store_product_card/Store_Product_Card";
import Common_Heading_Holder from "../../Common-Component/common_heading_holder/Common_Heading_Holder";
import { Swiper, SwiperSlide } from "swiper/react";
import "./New_In_Store.css";
import { getData } from "../../../utils/api";
import { Context } from "../../../utils/context";
import { NewInStore } from "../../../utils/apis/Product/Product";

const New_In_Store = ({ userId }) => {
  const data = [
    {
      name: "Chips",
      img: "/assets/Image/Homepage/new_arrval/img1.png",
      discount: 10,
    },
    {
      name: "Beverages",
      img: "/assets/Image/Homepage/new_arrval/img2.png",
    },
    {
      name: "Beverages",
      img: "/assets/Image/Homepage/new_arrval/img3.png",
      discount: 10,
    },
    {
      name: "Ice Cream and Frozen Desserts",
      img: "/assets/Image/Homepage/new_arrval/img4.png",
      discount: 10,
    },
    {
      name: "Biscuits, Cakes & Cookies",
      img: "/assets/Image/Homepage/new_arrval/img1.png",
    },
    {
      name: "Coffee & Tea",
      img: "/assets/Image/Homepage/new_arrval/img3.png",
    },
  ];

  const { IMG_URL, currentLocation } = useContext(Context);
  const [newinstore, setNewinstore] = useState([]);
  const getNewInStore = async () => {
    const city =
      currentLocation?.city ||currentLocation?.formatted_address ||
      currentLocation?.address_components?.[0]?.long_name ||
      "";
    const res = await NewInStore(userId, city);
    if (res?.success) {
      setNewinstore(res?.data);
    }
  };

  useEffect(() => {
    getNewInStore();
  }, [userId, currentLocation]);

  return (
    <section className="New_In_Store Store_details_New_In_Store">
      <div className="new_lottie_div">
        <New_Lottie />
      </div>

      <Common_Heading_Holder
        headingText={"New in Store"}
        viewShowAllButton
        goto={`/shop?user_id${userId}`}
      />

      <div className="store_content_div">
        <div className="new_store_swiper_div">
          <Swiper
            spaceBetween={15}
            pagination={{
              dynamicBullets: true,
              clickable: true,
            }}
            //   modules={[Pagination]}
            autoplay={{ delay: 300 }}
            className="common_swiper"
            breakpoints={{
              0: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              420: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              490: {
                slidesPerView: 3.5,
                spaceBetween: 20,
              },
              576: {
                slidesPerView: 2.5,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              992: {
                slidesPerView: 4,
                spaceBetween: 20,
              },
              1200: {
                slidesPerView: 4.5,
                spaceBetween: 20,
              },
              1400: {
                slidesPerView: 5,
                spaceBetween: 20,
              },
            }}
          >
            {newinstore?.map((item) => {
              return (
                <SwiperSlide>
                  <Store_Product_Card
                    id={item?.id}
                    img={IMG_URL + item?.image1}
                    name={item?.name}
                    discount={
                      item?.discount_type === "percentage"
                        ? `${item?.discount}%`
                        : item?.discount
                    }
                  />
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default New_In_Store;
